import React, { createContext, useState, useCallback, useEffect } from "react";

export const ShortlistContext = createContext({
  saved: [],
  surgeons: [],
  toggle: () => {},
  clear: () => {},
});

const STORAGE_KEY = "fscs_shortlist_v1";

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ids: [], surgeons: [] };
    return JSON.parse(raw);
  } catch {
    return { ids: [], surgeons: [] };
  }
}

function save(ids, surgeons) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ids, surgeons }));
  } catch {}
}

export function ShortlistProvider({ children }) {
  const [saved, setSaved] = useState(() => load().ids);
  const [surgeons, setSurgeons] = useState(() => load().surgeons);

  useEffect(() => {
    save(saved, surgeons);
  }, [saved, surgeons]);

  const toggle = useCallback((id, surgeonData) => {
    setSaved((prev) => {
      const next = prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id];
      setSurgeons((prevS) => {
        if (prev.includes(id)) {
          return prevS.filter((s) => s.id !== id);
        }
        if (surgeonData && !prevS.find((s) => s.id === id)) {
          return [...prevS, surgeonData];
        }
        return prevS;
      });
      return next;
    });
  }, []);

  const clear = useCallback(() => {
    setSaved([]);
    setSurgeons([]);
  }, []);

  return (
    <ShortlistContext.Provider value={{ saved, surgeons, toggle, clear }}>
      {children}
    </ShortlistContext.Provider>
  );
}
